// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._y44v1exl{animation:var(--_vn3mby)}._12vemgnk{background-repeat:no-repeat}\n._bfhk1cs6{background-color:var(--ds-background-accent-gray-subtlest,#ebecf0)}\n._bfhk1gk7{background-color:var(--ds-background-accent-gray-subtler,#c1c7d0)}\n._bfhk1hdx{background-color:var(--ds-background-accent-blue-subtlest,#deebff)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
